var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInscribeIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols-light:energy-savings-leaf-outline-sharp"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.0268 24C18.249 24 20.1264 23.2178 21.6588 21.6534C23.193 20.0889 23.9735 18.1982 24.0001 15.9814V8.00002H16.0188C13.801 8.02669 11.9104 8.80713 10.3468 10.3414C8.78237 11.8738 8.00015 13.7511 8.00015 15.9734C8.00015 18.1956 8.78059 20.0889 10.3415 21.6534C11.9006 23.2178 13.7953 24 16.0255 24M14.4001 21.0667L19.8228 16.2227L19.5081 15.336L15.5028 14.972L18.1161 11.408L17.6335 10.8667L12.2361 15.7174L12.5255 16.6307L16.5308 16.9947L13.9361 20.5507L14.4001 21.0667ZM16.0268 25.3334C14.8499 25.3334 13.7415 25.1302 12.7015 24.724C11.6615 24.3187 10.725 23.7605 9.89215 23.0494L7.33348 25.6174L6.38281 24.6667L8.95081 22.1067C8.2397 21.2747 7.68148 20.3387 7.27615 19.2987C6.86992 18.2587 6.66681 17.1507 6.66681 15.9747C6.66681 13.3765 7.57615 11.1756 9.39481 9.37202C11.2135 7.56846 13.4224 6.66669 16.0215 6.66669H25.3335V15.9774C25.3335 18.5774 24.4317 20.7862 22.6281 22.604C20.8246 24.4236 18.6241 25.3334 16.0268 25.3334Z",
    fill: "url(#paint0_linear_205_536)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_205_536",
    x1: 15.8581,
    y1: 6.66669,
    x2: 25.6477,
    y2: 7.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CD23E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC00FD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInscribeIco);
export default __webpack_public_path__ + "static/media/inscribe-ico.a609a01c6a474cb4c9a6beb0b00464ff.svg";
export { ForwardRef as ReactComponent };